import x from './HuntHorns';

export default x;
